import { useCallback } from 'react'
import { useFormContext } from 'react-hook-form'

import { useTranslation } from '../components/Translation'

// TODO: Currently doesn't support the translationPrefix logic
export function useTrigger() {
  const { trigger } = useFormContext()
  const { defaultLocale, locales = [], isTranslatable } = useTranslation() ?? {}

  return useCallback(
    async (names: string[]) => {
      const allNames = names.flatMap(function (name) {
        if (!isTranslatable?.(name)) return name

        return locales?.map(function (loc) {
          if (defaultLocale === loc) return name
          return `translations.${loc}.${name}`
        })
      })

      return await trigger(allNames)
    },
    [defaultLocale, locales, isTranslatable, trigger]
  )
}
